import { createFileRoute } from "@tanstack/react-router";
import { DienstLocatiePage, dienstLocatieHead } from "../components/DienstLocatiePage";
import { aanbouwDordrecht } from "../lib/dienst-locatie-content";

export const Route = createFileRoute("/aanbouw-dordrecht")({
  head: () => dienstLocatieHead(aanbouwDordrecht),
  component: () => <DienstLocatiePage content={aanbouwDordrecht} />,
});
